import React, { createRef } from 'react';
import { toast } from 'react-toastify';
import ModalContainer from 'react-modal-promise';
import cn from 'classnames';

import FormError from '../FormError';
import { refundPurchase } from 'actions/purchases';
import { connect } from 'react-redux';
import RefundPurchaseModal from './RefundPurchaseModal';

class RefundPurchase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isSent: false,
      error: undefined,
      showModal: false,
    };
    this.btnRef = createRef();
  }

  async handleRefund(purchaseId, values) {
    const { refundPurchase } = this.props;
    try {
      const response = await refundPurchase(purchaseId, values);
      if (
        (!Array.isArray(response?.errors) && response?.errors) ||
        (Array.isArray(response?.errors) && response?.errors.length)
      ) {
        const error =
          Array.isArray(response?.errors) && response?.errors.length
            ? response?.errors[0]
            : response?.errors;
        this.setState({
          error,
          isSent: false,
        });
        if (this.btnRef.current) {
          window.scrollTo({
            top: this.btnRef.current.offsetTop,
            behavior: 'smooth',
          });
        }
        toast.error('Refund request failed');
        return;
      }
      toast.success('Refund request completed');
    } catch (e) {
      const error = e?.errors?._error || e?.errors || e;
      this.setState({
        error,
        isSent: false,
      });
      toast.error('Refund request failed');
    }
  }

  async handleOpenModal() {
    await this.setState({ showModal: true });
    const confirmResult = await RefundPurchaseModal({
      open: this.state.showModal,
    });
    await this.setState({ showModal: false });
    if (confirmResult) {
      const { purchaseId } = this.props;
      const { cancelPurchase, refundId } = confirmResult;
      await this.handleRefund(purchaseId, {
        cancel_purchase: cancelPurchase,
        refund_id: refundId,
      });
    }
  }

  render() {
    const { isSent, error } = this.state;
    const { showRefund } = this.props;

    if (!showRefund && !error) {
      return null;
    }

    return (
      <React.Fragment>
        <button
          ref={this.btnRef}
          onClick={() => {
            this.handleOpenModal();
          }}
          className={cn('btn', 'btn-primary', {
            'mar-t': !showRefund && error,
          })}
          disabled={isSent}
        >
          Refund full purchase
        </button>
        {error ? <FormError error={error} /> : null}
        <ModalContainer />
      </React.Fragment>
    );
  }
}

const mapDispatchToProps = {
  refundPurchase,
};

export default connect(null, mapDispatchToProps)(RefundPurchase);
